import { X, Copy } from "react-feather";
import { toast } from "react-hot-toast";
import { DiscordIcon } from "@/assets/discord";

const DEFAULT_DISCORD_INVITE_URL = "https://discord.gg/SpP9vWt7hY";

interface JoinDiscordModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function JoinDiscordModal({ isOpen, onClose }: JoinDiscordModalProps) {
  const discordUrl =
    import.meta.env.VITE_DISCORD_INVITE_URL?.trim() || DEFAULT_DISCORD_INVITE_URL;

  const handleJoinDiscord = () => {
    window.open(discordUrl, "_blank");
  };

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(discordUrl);
      toast.success("Link copied to clipboard!");
    } catch (err) {
      console.error("Failed to copy link:", err);
      toast.error("Failed to copy link");
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-card rounded-2xl w-full max-w-lg mx-auto shadow-xl overflow-hidden">
        {/* Stylish header with Discord branding */}
        <div className="bg-gradient-to-br from-[#5865F2] via-[#7289da] to-[#5865F2] px-8 pt-8 pb-6 relative">
          <button
            onClick={onClose}
            className="absolute top-4 right-4 p-1.5 rounded-lg bg-card/20 hover:bg-card/30 text-white transition-colors"
            aria-label="Close"
          >
            <X className="h-5 w-5" />
          </button>
          <div className="flex flex-col items-center text-center">
            <div className="w-16 h-16 rounded-2xl bg-card/20 flex items-center justify-center mb-4 shadow-lg">
              <DiscordIcon className="w-10 h-10 text-white" />
            </div>
            <h2 className="text-2xl font-bold text-white mb-1">
              Join our FREE Discord
            </h2>
            <p className="text-white/95 text-base leading-relaxed max-w-sm">
              Start growing and earning as an affiliate
            </p>
          </div>
        </div>

        {/* Content and actions */}
        <div className="px-8 py-6">
          <p className="text-muted-foreground text-sm mb-4 text-center">
            Connect with other affiliates, get support, and access exclusive tips to grow your earnings.
          </p>

          {/* Visible link section */}
          <div className="flex items-center gap-2 mb-6 p-3 rounded-xl bg-muted border border-border">
            <span className="text-sm text-muted-foreground font-mono truncate flex-1 min-w-0">
              {discordUrl}
            </span>
            <button
              onClick={handleCopyLink}
              className="flex-shrink-0 inline-flex items-center gap-1.5 px-3 py-2 rounded-lg border border-border bg-card hover:bg-accent text-muted-foreground text-sm font-medium transition-colors"
              title="Copy link"
            >
              <Copy className="w-4 h-4" />
              Copy
            </button>
          </div>

          <div className="flex gap-3">
            <button
              onClick={handleJoinDiscord}
              className="flex-1 bg-[#5865F2] text-white rounded-xl py-3.5 hover:bg-[#4752C4] transition-colors font-semibold text-base shadow-md hover:shadow-lg"
            >
              Join Discord
            </button>
            <button
              onClick={onClose}
              className="px-5 py-3.5 border border-border rounded-xl hover:bg-accent transition-colors font-medium text-muted-foreground"
            >
              Maybe later
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
